import { render } from "./commaformatednumber.vue?vue&type=template&id=2e971a1c&scoped=true"
import script from "./commaformatednumber.vue?vue&type=script&lang=js"
export * from "./commaformatednumber.vue?vue&type=script&lang=js"

import "./commaformatednumber.vue?vue&type=style&index=0&id=2e971a1c&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e971a1c"]])

export default __exports__